import { buildAddressFormSchema } from '../address/create-form.js';
import { CustomerAddressType } from './rules.js';
export const customerAddressFormSchema = buildAddressFormSchema(CustomerAddressType, undefined, {
    requireFullAddress: true,
});
//# sourceMappingURL=create-form.js.map